// import { getUserInfo } from '@/services/login'
import { getToken, setToken, setreToken, removeToken, removereToken } from '@/utils/auth'

const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername ({ commit }, val) {
      // const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        // loginByUsername(username, userInfo.password).then(response => {
        //   const data = response.data
        //   commit('SET_TOKEN', data.token)
        //   setToken(response.data.token)
        //   resolve()
        // }).catch(error => {
        //   reject(error)
        // })

        commit('SET_TOKEN', val.data.access_token)
        setToken(val.data.access_token)
        setreToken(val.data.refresh_token)
        resolve()
      })
    },

    // refreshtoken登录
    LoginByrefresh ({commit}, val) {
      console.log(111)
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', val.data.access_token)
        setToken(val.data.access_token)

        resolve()
      })
    },

    // 获取用户信息
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        // getUserInfo(state.token).then(response => {
        //   // 由于mockjs 不支持自定义状态码只能这样hack
        //   if (!response.data) {
        //     reject(new Error('Verification failed, please login again.'))
        //   }
        //   const data = response.data

        //   if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
        //     commit('SET_ROLES', data.roles)
        //   } else {
        //     reject(new Error('getInfo: roles must be a non-null array!'))
        //   }

        //   commit('SET_NAME', data.name)
        //   commit('SET_AVATAR', data.avatar)
        //   commit('SET_INTRODUCTION', data.introduction)
        //   resolve(response)
        // }).catch(error => {
        //   reject(error)
        // })
        commit('SET_ROLES', [{ id: '1', name: 'admin' }])
        resolve([{ id: '1', name: 'editor' }])
      })
    },

    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
        //   commit('SET_TOKEN', '')
        //   commit('SET_ROLES', [])
        //   removeToken()
        //   resolve()
        // }).catch(error => {
        //   reject(error)
        // })
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        removereToken()
        resolve()
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles ({ commit, dispatch }, role) {
      return new Promise(resolve => {
        //   commit('SET_TOKEN', role)
        //   setToken(role)
        //   getUserInfo(role).then(response => {
        //     const data = response.data
        //     commit('SET_ROLES', data.roles)
        //     commit('SET_NAME', data.name)
        //     commit('SET_AVATAR', data.avatar)
        //     commit('SET_INTRODUCTION', data.introduction)
        //     dispatch('GenerateRoutes', data) // 动态修改权限后 重绘侧边菜单
        //     resolve()
        //   })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js